import { FunctionComponent } from 'react'
import { Grid } from '@material-ui/core'

import { Text, Title } from './styles'
import { colors } from 'shared/styles/colors'

interface BeneficioProp {
  title: string
  text: string
  icon: any
}
const Beneficio: FunctionComponent<BeneficioProp> = ({
  title,
  text,
  icon: Icon,
}) => {
  return (
    <Grid
      container
      justifyContent="flex-start"
      alignItems="flex-start"
      style={{ padding: 16 }}
    >
      <Grid item xl={1} lg={1} md={1} xs={1}>
        <Icon style={{ width: 16, height: 16, color: colors.green }} />
      </Grid>
      <Grid item xl={11} lg={11} md={11} xs={11}>
        <Title>{title}</Title>
        <Text>{text}</Text>
      </Grid>
    </Grid>
  )
}

export default Beneficio
